import get from 'lodash/get';
import pick from 'lodash/pick';

const selectPaymentMethod = action => ({
  event: 'selectPaymentMethod',
  isDefault: get(action, 'payload.isDefault', false),
  method: get(action, 'payload.method', null),
  orderId: get(action, 'payload.orderId', null),
});

const submitPayment = action => ({
  event: 'submitPayment',
  method: get(action, 'payload.method', null),
  orderId: get(action, 'payload.orderId', null),
  type: get(action, 'payload.type', null),
  confirmParameters: get(action, 'payload.confirmParameters', null),
  shouldRequestExtraBilling: get(action, 'payload.shouldRequestExtraBilling', null),
});

const paymentError = action => ({
  event: 'paymentError',
  error: get(action, 'payload.error', {}),
  message: get(action, 'payload.error.message', null),
  name: get(action, 'payload.error.name', null),
  code: get(action, 'payload.error.code', 'no_error_code'),
  stack: get(action, 'payload.error.stack', null),
  orderId: get(action, 'payload.orderId', null),
  method: get(action, 'payload.method', null),
  source: get(action, 'payload.source', null),
  shouldRequestExtraBilling: get(action, 'payload.shouldRequestExtraBilling', null),
});

const createOrder = ({ payload }) => ({
  event: payload.order?.payment?.total ? 'createOrder' : 'createFreeOrder',
  ...pick(payload.order, ['_id', 'uid', 'aid']),
});

const completeOrder = ({ payload }) => ({
  event: payload.paymentTotal ? 'completeOrder' : 'completeFreeOrder',
  _id: payload.transactionId,
});

const debug = ({ payload }) => ({
  event: 'paymentDebug',
  name: payload.name,
  ...payload.data,
});

export default {
  // TODO page navigation
  'frontend/payment/SELECT_PAYMENT_METHOD': selectPaymentMethod,
  'frontend/payment/SUBMIT_PAYMENT': submitPayment,
  'frontend/payment/PAYMENT_ERROR': paymentError,
  'frontend/payment/DEBUG': debug,
  'frontend/checkout/CREATE_ORDER': createOrder, // New, contains the full order
  'frontend/receipt/COMPLETE_ORDER': completeOrder, // New, contains the full order
  // TODO move split test in here
};
